$(document).ready(function () {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Trigger the counterUp only once when the element is in view
                $(entry.target).counterUp({
                    delay: 10,
                    time: 1000
                });
                observer.unobserve(entry.target); // Optionally unobserve the element to avoid re-triggering
            }
        });
    }, {
        threshold: 0.5 // Trigger when at least 50% of the element is visible
    });

    // Observe all elements with the class .js-count-up
    $('.js-count-up').each(function () {
        observer.observe(this);
    });
});
